import React, { useContext } from "react";
import { FiveQuestionsContext } from "./FiveQuestionsContext";
import closeSvg from "../../../assets/closeSvg";

const FiveQuestions = () => {
  const { fiveQuestionsVisible, setFiveQuestionsVisible } =
    useContext(FiveQuestionsContext);

  return (
    <div className={`fullScreen dark ${fiveQuestionsVisible ? "" : "down"}`}>
      <div className="fiveQuestionsContainer">
        <div>
          <div className="displayFlex spacebetween">
            <b>The 4 Questions</b>
            <span
              onClick={() => {
                setFiveQuestionsVisible(false);
              }}
            >
              {closeSvg}
            </span>
          </div>
          <ol>
            <li>How long have you been looking?</li>
            <li>Why did you start looking?</li>
            <li>What do you do for a living?</li>
            <li>Do you plan on financing the property or are you paying cash?</li>
          </ol>
        </div>
      </div>
    </div>
  );
};

export default FiveQuestions;
